import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-xl border-[1.5px] border-[#FFCAE2] bg-[#FFFCFE] px-4 py-3 text-base font-montserrat font-medium text-[#3D1F7A] ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[#FF91C0] focus-visible:outline-none focus-visible:border-2 focus-visible:border-[#3B82F6] focus-visible:ring-0 focus-visible:[box-shadow:0_0_0_3px_rgba(59,130,246,0.15)] disabled:cursor-not-allowed disabled:bg-[#FFF4FA] disabled:border-[#FFD6EB] disabled:text-[#A880F7] md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
